/* =============================================================================
   theme.js — kitcrochet (thème Shopify Online Store 2.0)

   Périmètre volontairement minimal (site-builder-shopify.md §Implémentation thème :
   "CSS/JS minimal, pas de dépendance lourde"). Aucune dépendance, aucun framework,
   aucun appel réseau, aucun traceur.

   Contenu (toujours en amélioration progressive, jamais de fonctionnalité perdue sans JS) :
     - bascule du menu de navigation en affichage mobile (le bouton est masqué par CSS
       au-dessus de 48rem et l'attribut `hidden` n'est jamais posé côté serveur) ;
     - galerie photo produit (vignettes cliquables, voir initProductGallery) ;
     - barre CTA sticky mobile sur la fiche produit (voir initStickyProductCta, ajouté
       2026-08-23 suite au retour direct de Dev sur la position du bouton "Ajouter au
       panier") ;
     - anti-chevauchement entre la bannière de consentement cookies native Shopify et la barre
       CTA sticky mobile (voir initCookieBannerOffset, ajouté 2026-08-23 suite à un contrôle
       visuel réel montrant la bannière masquant le CTA) ;
     - barre CTA sticky mobile sur la page panier (voir initStickyCartCta, ajoutée 2026-08-24,
       3e passe, suite à un contrôle visuel réel montrant le CTA "Passer la commande" recouvert
       par la bannière cookies même après restructuration de la ligne de panier).

   PAS de panier AJAX : jugé non pertinent à ce stade. Le catalogue est vide par
   construction (sites/kitcrochet/catalog/products.yaml, aucun fournisseur
   dropshipping identifié), donc aucun ajout au panier n'est réellement
   exerçable ni testable. Un panier AJAX non testé serait du code non vérifié
   livré dans le thème. Le formulaire produit et la page panier fonctionnent en
   POST natif Shopify, qui est le comportement de repli correct.
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 47.99rem)';

  function initNavToggle() {
    var toggle = document.querySelector('[data-kc-nav-toggle]');
    var nav = document.getElementById('kc-primary-nav');
    var label = toggle ? toggle.querySelector('[data-kc-nav-toggle-label]') : null;

    if (!toggle || !nav || typeof window.matchMedia !== 'function') {
      return;
    }

    var mql = window.matchMedia(MOBILE_QUERY);

    function setLabel(text) {
      // Le libellé visible doit refléter l'action disponible, pas seulement
      // aria-expanded (voir known-issues.md KI-05, corrigé le 2026-08-22).
      if (label && text) {
        label.textContent = text;
      }
    }

    function close() {
      nav.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      setLabel(toggle.getAttribute('data-label-open'));
    }

    function open() {
      nav.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      setLabel(toggle.getAttribute('data-label-close'));
    }

    function syncToViewport() {
      if (mql.matches) {
        // Passage en mobile : replie le menu, le bouton devient la commande.
        close();
      } else {
        // Passage en desktop : le bouton est masqué par CSS, la nav doit
        // redevenir visible quoi qu'il arrive.
        nav.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
        setLabel(toggle.getAttribute('data-label-open'));
      }
    }

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        close();
      } else {
        open();
      }
    });

    // Échap referme le menu et rend le focus au bouton (WCAG 2.2 — 2.1.2 no keyboard trap).
    nav.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && mql.matches) {
        close();
        toggle.focus();
      }
    });

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', syncToViewport);
    } else if (typeof mql.addListener === 'function') {
      // Repli pour Safari < 14.
      mql.addListener(syncToViewport);
    }

    syncToViewport();
  }

  // Correctif design 2026-08-22 (defaut visuel #3) : galerie photo produit.
  // Amelioration progressive uniquement : sans JS, l'image principale reste affichee et les
  // vignettes restent des <button> visibles (mais inertes). Aucune donnee n'est inventee ici,
  // seuls les attributs data-full-src/data-alt deja poses par sections/main-product.liquid
  // (issus de product.media, reellement chargé par Shopify) sont lus.
  function initProductGallery() {
    var galleries = document.querySelectorAll('[data-kc-gallery]');

    galleries.forEach(function (gallery) {
      var mainImage = gallery.querySelector('[data-kc-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-kc-gallery-thumb]');

      if (!mainImage || thumbs.length === 0) {
        return;
      }

      function activate(thumb) {
        var fullSrc = thumb.getAttribute('data-full-src');
        var alt = thumb.getAttribute('data-alt');

        if (fullSrc) {
          // On retire le srcset existant : sans cela, un navigateur peut continuer à choisir
          // une source de l'ancien srcset au lieu du src fraîchement posé.
          mainImage.removeAttribute('srcset');
          mainImage.src = fullSrc;
        }
        if (alt !== null) {
          mainImage.alt = alt;
        }

        thumbs.forEach(function (t) {
          var isActive = t === thumb;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activate(thumb);
        });
      });
    });
  }

  // Correctif UX 2026-08-23 (retour direct de Dev, voir sections/main-product.liquid) :
  // barre CTA sticky mobile. Amélioration progressive uniquement — sans JS ou sans
  // IntersectionObserver, l'attribut `hidden` posé côté serveur reste en place et rien ne
  // s'affiche ; le CTA principal (data-kc-primary-cta) est de toute façon déjà visible tôt
  // dans la page grâce à la réorganisation de la fiche produit. Le bouton sticky ne fait
  // jamais sa propre soumission : il déclenche un clic sur le vrai bouton du formulaire, qui
  // reste l'unique point de soumission du panier (aucune logique dupliquée).
  function initStickyProductCta() {
    var bars = document.querySelectorAll('[data-kc-sticky-cta]');

    if (!bars.length || typeof window.IntersectionObserver !== 'function' || typeof window.matchMedia !== 'function') {
      return;
    }

    var mql = window.matchMedia(MOBILE_QUERY);

    bars.forEach(function (bar) {
      var section = bar.closest('.kc-product');
      var mainButton = section ? section.querySelector('[data-kc-primary-cta]') : null;
      var trigger = bar.querySelector('[data-kc-sticky-cta-trigger]');

      if (!mainButton || !trigger) {
        return;
      }

      trigger.addEventListener('click', function () {
        mainButton.click();
      });

      function syncVisibility(isIntersecting) {
        bar.hidden = !(mql.matches && !isIntersecting);
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          syncVisibility(entry.isIntersecting);
        });
      }, { threshold: 0 });

      observer.observe(mainButton);

      function onViewportChange() {
        // Passage en desktop : la barre sticky ne doit jamais s'afficher, quel que soit
        // l'état d'intersection mémorisé par l'observer.
        if (!mql.matches) {
          bar.hidden = true;
        }
      }

      if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', onViewportChange);
      } else if (typeof mql.addListener === 'function') {
        // Repli pour Safari < 14.
        mql.addListener(onViewportChange);
      }
    });
  }

  // Correctif UX 2026-08-23 (3e passe, suite de mission — contrôle visuel réel par
  // visual-qa-inspector, voir reports/kitcrochet/theme/ux-fix-20260823-followup.md) :
  // la bannière de consentement cookies native Shopify (#shopify-pc__banner, injectée par
  // Shopify lui-même, pas un fichier de ce thème — voir assets/theme.css) et la barre CTA
  // sticky mobile (.kc-product__sticky-cta) sont toutes les deux en `position: fixed;
  // bottom: 0`. Sans coordination, tant que le consentement n'est pas donné, elles se
  // superposent et le bouton "Ajouter au panier" de la barre sticky reste caché derrière la
  // bannière. Cette fonction lit la hauteur réelle de la bannière (ResizeObserver — la
  // bannière est injectée de façon asynchrone par le script Shopify, donc surveillée via
  // MutationObserver le temps qu'elle apparaisse) et la reporte dans la variable CSS
  // `--kc-cookie-banner-offset`, utilisée par .kc-product__sticky-cta pour remonter d'autant.
  // Amélioration progressive : sans JS, la variable n'est jamais posée, `bottom: 0` reste la
  // valeur par défaut du CSS (comportement antérieur, pas de régression).
  function initCookieBannerOffset() {
    if (typeof window.ResizeObserver !== 'function' || typeof window.MutationObserver !== 'function') {
      return;
    }

    var root = document.documentElement;
    var resizeObserver = null;
    var observedBanner = null;

    function isBannerVisible(banner) {
      if (!banner) {
        return false;
      }
      var cs = window.getComputedStyle(banner);
      return cs.display !== 'none' && cs.visibility !== 'hidden';
    }

    function updateOffset() {
      var banner = document.getElementById('shopify-pc__banner');

      if (isBannerVisible(banner)) {
        root.style.setProperty('--kc-cookie-banner-offset', banner.getBoundingClientRect().height + 'px');
      } else {
        root.style.setProperty('--kc-cookie-banner-offset', '0px');
      }
    }

    function observeBanner(banner) {
      if (!banner || observedBanner === banner) {
        return;
      }

      if (resizeObserver) {
        resizeObserver.disconnect();
      }

      observedBanner = banner;
      resizeObserver = new ResizeObserver(updateOffset);
      resizeObserver.observe(banner);

      // Shopify affiche/masque la bannière via `style.display`, pas en la retirant du DOM
      // (constaté dans le DOM réel, voir assets/theme.css) : un changement d'attribut suffit,
      // pas besoin de re-détecter une insertion.
      new MutationObserver(updateOffset).observe(banner, { attributes: true, attributeFilter: ['style'] });

      updateOffset();
    }

    var existing = document.getElementById('shopify-pc__banner');
    if (existing) {
      observeBanner(existing);
    }

    // La bannière est injectée de façon asynchrone après le chargement de la page (script
    // Shopify chargé via {{ content_for_header }}) : on surveille son apparition dans le DOM.
    var bodyObserver = new MutationObserver(function () {
      var banner = document.getElementById('shopify-pc__banner');
      if (banner && observedBanner !== banner) {
        observeBanner(banner);
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Correctif visual-qa 2026-08-24 (3e passe, defaut MAJEUR #5 — filet de securite garanti, voir
  // sections/main-cart.liquid pour le detail complet du raisonnement). A la difference de
  // initStickyProductCta ci-dessus (qui se fie a IntersectionObserver, donc uniquement a la
  // sortie de viewport), cette fonction detecte EN PLUS le recouvrement reel par la banniere de
  // consentement cookies (position: fixed, donc jamais "hors intersection" au sens de
  // l'IntersectionObserver même quand elle recouvre visuellement un element par ailleurs dans le
  // viewport) : c'est exactement la cause du defaut mesure par visual-qa-inspector
  // (quality/kitcrochet/visual-qa/2026-08-24_0230.md — bouton a y:674-728, banniere a y:597-844,
  // superposition reelle malgre un bouton "visible" au sens du viewport). Amelioration
  // progressive : sans JS ou sans les API utilisees, `hidden` reste pose par le serveur et rien ne
  // s'affiche ; le bouton principal du formulaire reste de toute facon atteignable en scrollant
  // (voir le `padding-bottom` de `.kc-cart` pose lors de la 2e passe).
  function initStickyCartCta() {
    var bars = document.querySelectorAll('[data-kc-cart-sticky-cta]');

    if (!bars.length || typeof window.matchMedia !== 'function') {
      return;
    }

    var mql = window.matchMedia(MOBILE_QUERY);

    bars.forEach(function (bar) {
      var form = bar.closest('form');
      var mainButton = form ? form.querySelector('[data-kc-cart-primary-cta]') : null;
      var trigger = bar.querySelector('[data-kc-cart-sticky-cta-trigger]');

      if (!mainButton || !trigger) {
        return;
      }

      trigger.addEventListener('click', function () {
        mainButton.click();
      });

      function bannerRect() {
        var banner = document.getElementById('shopify-pc__banner');
        if (!banner) {
          return null;
        }
        var cs = window.getComputedStyle(banner);
        if (cs.display === 'none' || cs.visibility === 'hidden') {
          return null;
        }
        return banner.getBoundingClientRect();
      }

      function mainButtonSafelyVisible() {
        var rect = mainButton.getBoundingClientRect();

        // Hors du viewport (au-dessus ou en dessous) : pas visible, la barre doit s'afficher.
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) {
          return false;
        }

        // Recouvert par la banniere cookies fixe : visuellement masque malgre une intersection
        // viewport positive — c'est precisement la cause du defaut mesure.
        var banner = bannerRect();
        if (banner && rect.bottom > banner.top && rect.top < banner.bottom) {
          return false;
        }

        return true;
      }

      var scheduled = false;
      function sync() {
        scheduled = false;
        bar.hidden = !mql.matches || mainButtonSafelyVisible();
      }

      function scheduleSync() {
        if (scheduled) {
          return;
        }
        scheduled = true;
        window.requestAnimationFrame ? window.requestAnimationFrame(sync) : setTimeout(sync, 16);
      }

      window.addEventListener('scroll', scheduleSync, { passive: true });
      window.addEventListener('resize', scheduleSync);

      // La banniere cookies est injectee de facon asynchrone et se ferme via `style.display`
      // (voir assets/theme.css) : un changement d'attribut sur elle, ou son apparition dans le
      // DOM, doit redeclencher le calcul de recouvrement.
      if (typeof window.MutationObserver === 'function') {
        new MutationObserver(scheduleSync).observe(document.body, {
          attributes: true,
          attributeFilter: ['style'],
          childList: true,
          subtree: true,
        });
      }

      if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', scheduleSync);
      } else if (typeof mql.addListener === 'function') {
        // Repli pour Safari < 14.
        mql.addListener(scheduleSync);
      }

      sync();
      // Le premier calcul peut survenir avant que la banniere Shopify (chargee de facon
      // asynchrone) ait fini de se dessiner ou que --kc-cookie-banner-offset soit pose : quelques
      // recalculs differes garantissent l'etat final correct au premier affichage, sans dependre
      // d'un evenement precis de fin de chargement de la banniere tierce.
      setTimeout(scheduleSync, 300);
      setTimeout(scheduleSync, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavToggle);
    document.addEventListener('DOMContentLoaded', initProductGallery);
    document.addEventListener('DOMContentLoaded', initStickyProductCta);
    document.addEventListener('DOMContentLoaded', initCookieBannerOffset);
    document.addEventListener('DOMContentLoaded', initStickyCartCta);
  } else {
    initNavToggle();
    initProductGallery();
    initStickyProductCta();
    initCookieBannerOffset();
    initStickyCartCta();
  }
})();
